import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { formatApiError } from "../lib/api";
import { ArrowLeft } from "@phosphor-icons/react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      const { joinedLeagueId } = await login(email.trim(), password);
      if (joinedLeagueId) {
        nav(`/app/leagues/${joinedLeagueId}`, { replace: true });
      } else {
        nav("/app", { replace: true });
      }
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="app-shell min-h-screen p-6 flex flex-col">
      <Link to="/" data-testid="back-to-landing" className="btn-ghost self-start -ml-2">
        <ArrowLeft size={20} weight="bold" /> Back
      </Link>

      <div className="flex items-center mt-6 mb-2" data-testid="login-logo">
        <img src="/fairway-logo.png" alt="Fairway" className="h-16 w-auto rounded-2xl" />
      </div>

      <h1 className="font-heading font-black tracking-tighter-2 text-4xl sm:text-5xl text-[var(--primary)] mt-6 mb-2">
        Welcome back
      </h1>
      <p className="text-[var(--text-secondary)] mb-8">Sign in to track your round and your league.</p>

      <form onSubmit={handleSubmit} className="flex flex-col gap-4" data-testid="login-form">
        <div>
          <label className="label-uppercase block mb-2">Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="input-field"
            placeholder="you@example.com"
            data-testid="login-email-input"
          />
        </div>
        <div>
          <label className="label-uppercase block mb-2">Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="input-field"
            placeholder="Your password"
            data-testid="login-password-input"
          />
        </div>

        {error && (
          <div data-testid="login-error" className="text-sm text-[var(--status-bad)] bg-red-50 border border-red-200 rounded-xl px-4 py-3">
            {error}
          </div>
        )}

        <button
          type="submit"
          className="btn-primary mt-2"
          disabled={submitting}
          data-testid="login-submit-button"
        >
          {submitting ? "Signing in..." : "Sign in"}
        </button>
      </form>

      <p className="text-center mt-4 text-sm">
        <Link to="/forgot-password" data-testid="link-to-forgot" className="text-[var(--primary)] underline">
          Forgot your password?
        </Link>
      </p>

      <p className="text-center mt-6 text-[var(--text-secondary)]">
        New here? <Link to="/register" data-testid="link-to-register" className="text-[var(--primary)] font-semibold underline">Create an account</Link>
      </p>
    </div>
  );
}
